import React from 'react';
import './App.css';
import ContractQuery from './components/ContractQuery';

function App() {
  return (
    <div className="App">
      {/* <header className="App-header">
        <h1>Ethereum コントラクトクエリアプリ</h1>
        <p>特定のコントラクトのメソッドを呼び出して結果を表示します</p>
      </header> */}
      <main>
        <ContractQuery />
      </main>
    </div>
  );
}

export default App;
